export default "/bitrix/js/landing/ui/panel/formsettingspanel/content/actions/dist/images/type2.svg"